import { flow, sortBy } from 'lodash';

// Utilities ////////////////////
export const pipe = (arg, ...fs) => flow(...fs)(arg);

export { property as prop } from 'lodash';

export { compose } from 'lodash/fp';

export function id(arg) {
  return arg;
}

export function not(condition) {
  if (typeof condition === 'function') {
    return (...args) => !condition(...args);
  }

  return () => !condition;
}

export function eq(valueA) {
  return (valueB) => valueA === valueB;
}

export function cond(a, b) {
  return (condition) => (condition ? a : b || undefined);
}

// Logging ////////////////////
const getLogMessage = (message, data) => (typeof message === 'function' ? message(data) : message);

export function log(...args) {
  return (data) => {
    console.log(...args.map((arg) => getLogMessage(arg, data)));
    return data;
  };
}

// Array ////////////////////
export const size = (array = []) => array.length;

export const isLastIndex = (array = []) => (index) => index === size(array) - 1;

export const isFirstIndex = (index) => index === 0;

export const find = (f) => (array = []) => array.find(f);

export const filter = (f) => (array = []) => array.filter(f);

export const head = (array = []) => array[0];

export const last = (array = []) => array[size(array) - 1];

export const map = (f) => (array = []) => array.map(f);

export const join = (separator) => (array = []) => array.join(separator);

export const reverse = (array = []) => array.reverse();

export const reduce = (f) => (b) => (as) => as.reduce(f, b);

export const includes = (a) => (array = []) => array.includes(a);

export const empty = (array = []) => array.length === 0;

export const notEmpty = not(empty);

export const compact = (array = []) => array.filter((x) => !!x);

export const slice = (start, end) => (array = []) => array.slice(start, end);

export const push = (a) => (array = []) => [...array, a];

export const unshift = (a) => (array = []) => [a, ...array];

export const sort = (...fields) => (array = []) => sortBy(array, fields);

// String ////////////////////
export const toUpperCase = (str = '') => str.toUpperCase();

export const toLowerCase = (str = '') => str.toLowerCase();

export const startsWith = (query) => (str = '') => str.startsWith(query);

export const split = (separator) => (array = []) => array.join(separator);

export const padStart = (length, fill) => (str = '') => str.padStart(length, fill);

export const padEnd = (length, fill) => (str = '') => str.padEnd(length, fill);
